import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ data, interestType }) => {
  const data1 = {
    labels: Object.keys(data.bar_chart_stack_1.data.ir1),
    datasets: [
      {
        label: "Startkapital",
        data: data.bar_chart_stack_3.data[interestType],
        backgroundColor: "#2F7ED8",
      },
      {
        label: "Eingesetztes Kapital",
        data: data.bar_chart_stack_2.data[interestType],
        backgroundColor: "#07053A",
      },
      {
        label: "Zinsertrag Total",
        data: data.bar_chart_stack_1.data[interestType],
        backgroundColor: "#BCA15E",
      },
    ],
  };

  const options = {
    plugins: {
      title: {
        display: false,
        text: "Stacked Bar Chart",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          font: {
            size: 12,
            family: "Arial",
            weight: "bold",
          },
        },
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  return (
      <Bar data={data1} options={options} />
  );
};

export default BarChart;
